import { SizableText, YStack, YStackProps } from '@my/ui'
import { formatTimeToNow } from 'app/utils/format-time-to-now'

interface OfferEndTimeTagProps {
  expiresAt: string
}

export const OfferEndTimeTag = ({ expiresAt, ...props }: OfferEndTimeTagProps & YStackProps) => {
  return (
    <YStack py="$1.5" px="$2" br="$2" bc="$primary4" jc="center" {...props}>
      <SizableText size="$2" textAlign="center" textTransform="uppercase">
        ends {formatTimeToNow(expiresAt)}
      </SizableText>
    </YStack>
  )
}
